<template>
  <div class="bg-[rgb(15,23,42)] py-3 px-6 sticky top-0 z-50">
    <div class="container mx-auto max-w-[1200px]">
      <div class="flex items-center justify-between py-3">
        <!-- <router-link :to="{ name: 'InstructorHome' }" class="brand w-nav-brand w--current flex items-center">
          <img :src="logo_image" alt="" class="w-40 py-4 object-fit" />
        </router-link> -->

        <router-link
          :to="{ name: 'InstructorHome' }"
          class="brand w-nav-brand w--current flex items-center"
        >
          <img
            :src="logo_image"
            alt="Logo"
            class="w-20 sm:w-24 md:w-32 lg:w-36 xl:w-40 object-contain"
          />
        </router-link>

        <div class="flex items-center">
          <div
            class="text-[#0085DB] px-5 font-bold hidden md:block"
            v-if="this.userInfo"
          >
            {{
              this.userInfo.user.permission.charAt(0).toUpperCase() +
              this.userInfo.user.permission.slice(1)
            }}
          </div>
          <div class="hidden md:flex items-center gap-5">
            <div class="mr-10 flex items-center gap-10">
              <div class="relative cursor-pointer dropdown-container">
                <div
                  class="menu-trigger group relative flex cursor-pointer items-center gap-2 rounded-full px-4 py-2 backdrop-blur-sm transition-all duration-300 hover:bg-white/10 hover:shadow-lg active:scale-95"
                  @click="MenuToggle('menu')"
                  :class="
                    toggleMenuName === 'menu' ? 'bg-white/10 shadow-lg' : ''
                  "
                >
                  <p class="text-sm font-semibold text-white tracking-wide">
                    Menu
                  </p>

                  <svg
                    class="h-3 w-3 text-white transition-transform duration-300"
                    :class="toggleMenuName === 'menu' ? 'rotate-180' : ''"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>

                <div
                  class="absolute right-0 top-12 z-50 bg-white rounded-2xl shadow-lg"
                  style="width: 180px"
                  v-if="toggleMenuName == 'menu'"
                >
                  <!-- <router-link
                    :to="{ name: 'InstructorNewCourses' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                    :class="{
                      'text-[#0085db]': $route.name === 'InstructorNewCourses',
                      'text-black': $route.name !== 'InstructorNewCourses',
                    }"
                  >
                    New Course</router-link
                  >
                  <hr /> -->
                  <router-link
                    :to="{ name: 'AdminCoursess' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hover:rounded-t-2xl"
                    :class="{
                      'text-[#0085db]': $route.name === 'AdminCoursess',
                      'text-black': $route.name !== 'AdminCoursess',
                    }"
                  >
                    All Courses</router-link
                  >
                  <hr />
                  <!-- 
                  <router-link
                    :to="{ name: 'InstructorStudentAssign' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]':
                        $route.name === 'InstructorStudentAssign',
                      'text-black': $route.name !== 'InstructorStudentAssign',
                    }"
                  >
                    <p>Student Assign</p>
                  </router-link>

                  <hr /> -->

                  <router-link
                    :to="{ name: 'HodBatches' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'HodBatches',
                      'text-black': $route.name !== 'HodBatches',
                    }"
                  >
                    Batches</router-link
                  >
                  <hr />

                  <router-link
                    :to="{ name: 'instructorCounts' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'instructorCounts',
                      'text-black': $route.name !== 'instructorCounts',
                    }"
                  >
                    Students</router-link
                  >
                  <!-- <hr /> -->

                  <!-- <router-link
                    :to="{ name: 'InstructorBlogsView' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'InstructorBlogsView',
                      'text-black': $route.name !== 'InstructorBlogsView',
                    }"
                  >
                    New Blog</router-link
                  > -->

                  <hr />

                  <router-link
                    :to="{ name: 'InstructorBlogsList' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'InstructorBlogsList',
                      'text-black': $route.name !== 'InstructorBlogsList',
                    }"
                  >
                    Blogs</router-link
                  >

                  <hr />

                  <router-link
                    :to="{ name: 'DownloadHistory' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hover:rounded-b-2xl"
                    :class="{
                      'text-[#0085db]': $route.name === 'DownloadHistory',
                      'text-black': $route.name !== 'DownloadHistory',
                    }"
                  >
                    Download History</router-link
                  >

                  <hr />

                  <!-- <router-link :to="{ name: 'InstructorInviteCourse' }" class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer" :class="{ 'text-[#0085db]': $route.name === 'InstructorInviteCourse','text-black': $route.name !== 'InstructorInviteCourse' }">
               Invite Course</router-link> -->
                  <!-- <div>
                    <button
                      @click="
                        this.invitecourse = true;
                        toggleMenuName = '';
                      "
                      class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                      :class="{
                        ' text-[#0085db]': invitecourse,
                        ' text-black': !invitecourse,
                      }"
                    >
                      Invite Course
                    </button>
                  </div> -->

                  <!-- <div class="flex items-center gap-2 py-3 px-6 cursor-pointer">
                  <router-link
                    :to="{ name: 'InstructorCourses' }"
                    class="text-xs font-medium"
                    style="color: #333333 !important"
                    >Courses</router-link
                  >
                </div> -->

                  <!-- <div class="flex items-center gap-2 py-3 px-6 cursor-pointer">
                <p
                  class="text-xs text-[#F87474] font-semibold"
                  style="color: #f87474 !important"
                  @click="logOut"
                >
                  Course with AI
                </p>
              </div> -->
                </div>
              </div>
              <!-- <div>
              <router-link
                :to="{ name: 'Community' }"
                class="text-xs text-white hover:text-white font-medium"
                >Community</router-link
              >
            </div>
            <div>
              <router-link
                :to="{ name: 'StudentCourseCurriculum' }"
                class="text-xs text-white hover:text-white font-medium"
                >Curriculum</router-link
              >
            </div> -->
            </div>
          </div>

          <!-- Message -->

          <div class="mr-7 relative dropdown-container">
            <div
              class="relative p-1 rounded-md hover:bg-white/20"
              :class="
                toggleMenuName === 'messages' ||
                $route.name === 'StudentMessagesList'
                  ? 'bg-white/20'
                  : ''
              "
              @click="MenuToggle('messages')"
            >
              <p
                class="bg-white flex items-center justify-center text-primary !w-[25px] !h-[25px] text-xs rounded-full absolute -top-6 -right-5"
              >
                {{ messageCount || 0 }}
              </p>

              <img
                src="@/assets/new/chat.svg"
                width="20"
                height="20"
                class="cursor-pointer"
              />
            </div>
            <div
              v-if="toggleMenuName == 'messages'"
              class="absolute right-[-120px] lg:right-0 top-14 lg:top-10 w-64 z-10 bg-white rounded-2xl shadow-lg p-4"
            >
              <div class="font-bold text-sm pb-3 flex items-center gap-2">
                Messages
                <p
                  class="bg-primary flex items-center justify-center text-white !w-[25px] !h-[25px] text-xs rounded-full"
                  v-if="messageCount != 0"
                >
                  {{ messageCount }}
                </p>
              </div>

              <div class="flex flex-col gap-2">
                <div v-if="messageList.length != 0" class="flex flex-col gap-2">
                  <router-link
                    :to="{ name: 'StudentMessagesList' }"
                    class="flex flex-col border gap-1 py-2 px-4 rounded-lg hover:bg-gray-100"
                    :class="{
                      'bg-white border-blue-500 shadow-md ring-1 ring-blue-100 hover:bg-blue-50':
                        !message.readed,
                      'bg-white border-gray-300 hover:bg-gray-100 hover:border-gray-300':
                        message.readed,
                    }"
                    v-for="(message, index) in messageList.slice(0, 3)"
                    :key="message.id || index"
                  >
                    <h4
                      class="text-xs truncate transition-colors uppercase font-bold"
                      :class="
                        !message.readed
                          ? 'font-bold text-slate-900'
                          : 'font-medium text-slate-600'
                      "
                    >
                      {{ message.owner_display_name || "NA" }}
                    </h4>
                    <div
                      class="text-[12px] tracking-tight flex w-full"
                      :class="
                        !message.readed
                          ? 'text-slate-700 font-medium'
                          : 'text-slate-500 font-normal'
                      "
                    >
                      <p class="line-clamp-1 w-full">
                        {{ message.course_title || "NA" }}
                      </p>
                    </div>
                    <p
                      class="text-xs line-clamp-1"
                      :class="
                        !message.readed
                          ? 'text-slate-700 font-medium'
                          : 'text-slate-500 font-normal'
                      "
                    >
                      {{ message.text || "No preview available..." }}
                    </p>
                    <p
                      class="text-xs"
                      :class="
                        !message.readed
                          ? 'text-slate-700 font-medium'
                          : 'text-slate-500 font-normal'
                      "
                    >
                      {{ formatDateTime(message.created_at) }}
                    </p>
                  </router-link>

                  <router-link
                    :to="{ name: 'StudentMessagesList' }"
                    v-if="messageList.length > 3"
                    class="text-blue-600 hover:text-blue-700 font-bold text-xs py-2 text-end"
                  >
                    See More
                  </router-link>
                </div>
                <router-link
                  :to="{ name: 'StudentMessagesList' }"
                  v-if="this.messageList.length == 0"
                  class="flex text-sm flex-col border gap-1 py-2 px-4 rounded-lg"
                  >No Data Found</router-link
                >
              </div>
            </div>
          </div>

          <div class="mr-10 relative dropdown-container">
            <div
              class="relative p-1 rounded-md hover:bg-white/20"
              :class="
                toggleMenuName === 'notification' ||
                $route.name === 'StudentNotifications'
                  ? 'bg-white/20'
                  : ''
              "
              @click="MenuToggle('notification')"
            >
              <p
                class="bg-white flex items-center justify-center text-primary !w-[25px] !h-[25px] text-xs rounded-full absolute -top-5 -right-5"
              >
                {{ notificationCount || 0 }}
              </p>

              <img
                src="@/assets/notification.png"
                width="24"
                height="24"
                class="cursor-pointer"
              />
            </div>

            <div
              class="absolute right-[-70px] lg:right-0 top-14 lg:top-10 w-64 z-10 bg-white rounded-2xl shadow-lg p-4"
              style="width: 250px"
              v-if="toggleMenuName == 'notification'"
            >
              <div
                class="font-bold text-sm pb-3 flex items-center gap-2 border-b border-gray-50 mb-2"
              >
                Notifications
                <span
                  v-if="notificationCount > 0"
                  class="bg-blue-600 flex items-center justify-center text-white w-5 h-5 text-[10px] rounded-full animate-pulse"
                >
                  {{ notificationCount }}
                </span>
              </div>

              <div class="flex flex-col gap-2">
                <!-- Notification List -->
                <div
                  v-if="notificationList.length > 0"
                  class="flex flex-col gap-2"
                >
                  <router-link
                    v-for="(notifi, index) in notificationList.slice(0, 3)"
                    :key="index"
                    :to="{ name: 'StudentNotifications' }"
                    class="flex flex-col border transition-all duration-200 gap-1 py-2 px-4 rounded-lg group"
                    :class="[
                      !notifi.read
                        ? 'bg-white border-blue-400 shadow-sm ring-1 ring-blue-50 hover:bg-blue-50'
                        : 'bg-slate-50 border-slate-200 opacity-80 hover:opacity-100 hover:bg-white hover:border-slate-300',
                    ]"
                  >
                    <!-- Content -->
                    <div class="flex justify-between items-start">
                      <p
                        class="font-bold text-xs truncate group-hover:text-blue-700"
                        :class="
                          !notifi.read ? 'text-gray-900' : 'text-gray-500'
                        "
                      >
                        {{ notifi.topic }}
                      </p>

                      <!-- Optional: Blue dot indicator for Unread -->
                      <span
                        v-if="!notifi.read"
                        class="flex h-2 w-2 rounded-full bg-blue-600"
                      ></span>
                    </div>

                    <p class="text-[10px] text-gray-400">
                      {{ formatDate(notifi.created_at) }}
                    </p>
                  </router-link>

                  <!-- View All Link -->
                  <router-link
                    v-if="notificationList.length > 3"
                    :to="{ name: 'StudentNotifications' }"
                    class="text-blue-600 hover:text-blue-800 hover:underline font-bold text-xs py-2 text-center transition-all"
                  >
                    See More
                  </router-link>
                </div>

                <!-- Empty State -->
                <div
                  v-else
                  class="flex flex-col items-center justify-center py-6 px-4 border border-dashed border-gray-200 rounded-lg"
                >
                  <p class="text-gray-400 text-xs">No Data Found</p>
                </div>
              </div>
            </div>
          </div>

          <div class="relative dropdown-container">
            <div
              @click="MenuToggle('profile')"
              class="flex items-center cursor-pointer"
            >
              <!-- {{ userInfo.image }}  -->

              <img
                v-if="userInfo && userInfo.image && userInfo.image != null"
                :src="userInfo.image"
                :class="[
                  'w-10 h-10 rounded-full border-2 transition-all duration-200',
                  toggleMenuName === 'profile' ||
                  $route.name === 'InstructorProfile'
                    ? 'border-blues'
                    : 'border-white hover:border-blue-600',
                ]"
              />
              <img
                v-else
                src="@/assets/new/image.png"
                :class="[
                  'w-10 h-10 rounded-full border-2 transition-all duration-200',
                  toggleMenuName === 'profile' ||
                  $route.name === 'InstructorProfile'
                    ? 'border-blues'
                    : 'border-white hover:border-blue-600',
                ]"
              />

              <!-- <img
                v-if="isAuthenticated && profileInfo != null && profileInfo.data.profile"
                :src="profileInfo.data.profile"
                class="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                v-else
                src="@/assets/new/image.png"
                class="w-10 h-10 rounded-full border-2 border-white"
              /> -->
            </div>

            <!-- <div
              @click="MenuToggle('profile')"
              class="flex items-center cursor-pointer gap-2"
            >
              <div class="flex items-center">
                <div
                  v-if="
                    isAuthenticated &&
                    profileInfo != null &&
                    profileInfo.data.profile != ''
                  "
                >
                  <img
                   v-if="userInfo.image && userInfo.image != null"
                    :src="userInfo.image"
                    alt=""
                    class="w-10 h-10 rounded-full border-2 border-white"
                  />
                </div>
                <div v-else>
                  <img
                    src="@/assets/new/image.png"
                    alt=""
                    class="w-10 h-10 rounded-full border-2 border-white hidden"
                  />
                  <img
                    src="@/assets/newd/Group 151.png"
                    alt=""
                    class="w-10 h-10 rounded-full border-2 border-white"
                  />
                </div>
              </div>
            </div> -->

            <div
              class="absolute right-0 top-14 lg:top-20 z-50 bg-white rounded-2xl shadow-lg"
              style="width: 180px"
              v-if="toggleMenuName == 'profile'"
            >
              <!-- <div class="flex items-center gap-2 py-3 px-6 cursor-pointer">
                <img
                  src="@/assets/new/profile.png"
                  width="20"
                  height="20"
                  alt=""
                />

                <router-link
                  :to="{ name: 'StudentHome' }"
                  class="text-xs font-medium"
                  style="color: #333333 !important"
                  >Profile</router-link
                >
              </div> -->

              <router-link
                :to="{ name: 'InstructorProfile' }"
                class="flex items-center gap-2 py-3 px-4 text-xs cursor-pointer hover:bg-slate-200 hover:rounded-t-2xl"
              >
                <img
                  src="@/assets/new/profile.png"
                  class="w-5 h-5"
                  alt="Profile"
                />
                <div>
                  <span
                    class="font-semibold"
                    :class="{
                      'text-[#0085db]': $route.name === 'InstructorProfile',
                      'text-gray-800': $route.name !== 'InstructorProfile',
                    }"
                    >Profile</span
                  >
                  <!-- <span>62135458</span>
                  <span>Compt Science</span> -->
                </div>
              </router-link>

              <!-- 
              <router-link
                :to="{ name: 'InstructorCourses' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              >
               

                <p>Courses</p>
              </router-link> -->

              <hr />
              <router-link
                v-if="checkinTheList('Timetable')"
                :to="{ name: 'AttendanceTimeTable' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hidden"
                :class="{
                  'text-[#0085db]': $route.name === 'AttendanceTimeTable',
                  'text-gray-800': $route.name !== 'AttendanceTimeTable',
                }"
              >
                Time Table</router-link
              >
              <!-- <hr v-if="checkinTheList('Timetable')" /> -->
              <router-link
                v-if="checkinTheList('Attendance')"
                :to="{ name: 'InstructorAttendance' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hidden"
                :class="{
                  'text-[#0085db]': $route.name === 'InstructorAttendance',
                  'text-gray-800': $route.name !== 'InstructorAttendance',
                }"
              >
                Attendance</router-link
              >
              <!-- <hr v-if="checkinTheList('Attendance')" /> -->

              <!-- <router-link
                :to="{ name: 'MyTask' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'MyTask',
                  'text-gray-800': $route.name !== 'MyTask',
                }"
              >
                My Task</router-link
              >
              <hr /> -->
              <router-link
                :to="{ name: 'SyallbusView' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'SyallbusView',
                  'text-gray-800': $route.name !== 'SyallbusView',
                }"
              >
                User Instructions
              </router-link>
              <hr />
              <router-link
                :to="{ name: 'StroageFilesView' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'StroageFilesView',
                  'text-black': $route.name !== 'StroageFilesView',
                }"
              >
                My Drive
              </router-link>
              <hr />
              <router-link
                :to="{ name: 'HomeHelpIn' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hidden hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'HomeHelpIn',
                  'text-black': $route.name !== 'HomeHelpIn',
                }"
              >
                help
              </router-link>
              <hr />
              <!-- <router-link
                :to="{ name: 'SupportView' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              >
                Support</router-link
              > -->
              <!-- <a href="https://coms.cambridge.edu.in/" class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer" target="blank"> Support</a>
              <hr /> -->

              <div
                class="flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hover:rounded-b-2xl"
                @click="
                  LogOutModal = true;
                  toggleMenuName = '';
                "
              >
                <img
                  src="@/assets/new/logout.png"
                  width="15"
                  height="15"
                  alt=""
                />
                <p
                  class="text-xs text-[#F87474] font-semibold"
                  style="color: #f87474 !important"
                >
                  Logout
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="lg:hidden md:hidden relative dropdown-container">
          <button
            @click="MenuToggle('mobile_menu')"
            class="text-white focus:outline-none"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
          <div
            v-if="toggleMenuName == 'mobile_menu'"
            class="absolute right-6 top-20 z-50 bg-white rounded-2xl shadow-lg lg:hidden"
            style="width: 180px"
          >
            <router-link
              :to="{ name: 'AdminCoursess' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'AdminCoursess',
                'text-black': $route.name !== 'AdminCoursess',
              }"
            >
              All Courses</router-link
            >
            <hr />
            <router-link
              :to="{ name: 'InstructorStudentAssign' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'InstructorStudentAssign',
                'text-black': $route.name !== 'InstructorStudentAssign',
              }"
            >
              <p>Student Assign</p>
            </router-link>

            <hr />

            <router-link
              :to="{ name: 'HodBatches' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'HodBatches',
                'text-black': $route.name !== 'HodBatches',
              }"
            >
              Batches</router-link
            >
            <hr />

            <router-link
              :to="{ name: 'instructorCounts' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'instructorCounts',
                'text-black': $route.name !== 'instructorCounts',
              }"
            >
              Students</router-link
            >
            <hr />

            <router-link
              :to="{ name: 'InstructorBlogsView' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'InstructorBlogsView',
                'text-black': $route.name !== 'InstructorBlogsView',
              }"
            >
              New Blog</router-link
            >

            <hr />

            <router-link
              :to="{ name: 'InstructorBlogsList' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'InstructorBlogsList',
                'text-black': $route.name !== 'InstructorBlogsList',
              }"
            >
              Blogs</router-link
            >
            <hr />
            <div>
              <button
                @click="
                  this.invitecourse = true;
                  toggleMenuName = '';
                "
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                :class="{
                  ' text-[#0085db]': invitecourse,
                  ' text-black': !invitecourse,
                }"
              >
                Invite Course
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- invite course popup start -->
    <div
      v-if="this.invitecourse"
      @click.self="this.invitecourse = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
    >
      <div class="md:w-[40%] 2xl:w-[35%] bg-white rounded-xl p-10">
        <div class="flex items-center justify-center">
          <h3 class="text-xl font-bold text-blues text-center">
            Invite Course
          </h3>
        </div>

        <div
          class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
        >
          <div class="w-full">
            <form
              ref="createTeamRef"
              @submit.prevent="invitepost"
              class="flex flex-col gap-4 text-xs md:text-xs lg:text-base h-full"
            >
              <div class="flex flex-col gap-3 w-full">
                <label for="category" class="flex gap-2 items-center">
                  <div>
                    Course list
                    <span class="text-red-400">*</span>
                  </div>
                </label>
                <select
                  name="course"
                  class="bg-[#F9FAFC] rounded-lg text-xs w-full p-3 border-none outline-none"
                  id="course"
                  required
                >
                  <option value="" disabled selected>Select course</option>
                  <option
                    v-for="course in courselist"
                    :key="course"
                    :value="course.title"
                  >
                    {{ course.title }}
                  </option>
                </select>
              </div>

              <!-- <div class="flex flex-col gap-3 w-full">
                <label for="category" class="flex gap-2 items-center">
                  <div>
                    Student list
                    <span class="text-red-400">*</span>
                  </div>
                </label>

                <select
                  name="studentmail"
                  class="bg-[#F9FAFC] rounded-lg text-xs w-full p-3 border-none outline-none"
                  id="studentmail"
                >
                 <option value="" disabled selected>Select email</option>
                  <option
                    v-for="student in studentlist"
                    :key="student"
                    :value="student.email"
                  >
                    {{ student.email }}
                  </option>
                </select>
              </div> -->

              <div class="flex flex-col gap-3 w-full">
                <label for="studentmail" class="flex gap-2 items-center">
                  <div>Student list <span class="text-red-400">*</span></div>
                </label>

                <input
                  type="text"
                  id="studentmail"
                  v-model="searchQuery"
                  @input="Studentsearch"
                  placeholder="Search email"
                  class="bg-[#F9FAFC] rounded-lg text-xs w-full p-3 border-none outline-none"
                />
                <ul
                  v-if="showdetail == false && this.studentlist.length > 0"
                  class="bg-white w-full border rounded-lg shadow-md h-[150px] overflow-y-auto mt-1"
                >
                  <li
                    v-for="student in studentlist.slice(0, lengthCount)"
                    :key="student.email"
                    class="p-2 cursor-pointer hover:bg-gray-100"
                    @click="selectStudent(student.email)"
                  >
                    {{ student.email }}
                  </li>
                </ul>
              </div>

              <div class="flex justify-center pb-4 mt-3 gap-10">
                <button
                  @click="closepopup"
                  class="border text-gray-500 rounded-lg text-xs px-10 font-semibold py-2"
                >
                  Close
                </button>
                <div class="flex gap-3 items-center">
                  <button
                    :disabled="disableStatus"
                    :class="{
                      'cursor-not-allowed bg-gray-200 text-black':
                        disableStatus === true,
                      'cursor-pointer bg-blues text-white ':
                        disableStatus === false,
                    }"
                    type="submit"
                    class="rounded-lg text-xs px-10 font-semibold py-2"
                  >
                    Invite
                  </button>
                  <div v-if="loaders" class="spinner"></div>
                </div>
              </div>
              <div
                v-if="invite_messages"
                class="text-green-500 font-bold text-left px-2 py-2 rounded-lg"
              >
                {{ invite_messages }}
              </div>
              <div
                v-if="invite_err_messages"
                class="text-red-500 font-bold text-left px-2 py-2 rounded-lg"
              >
                {{ invite_err_messages }}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- invite course popup end -->
    <Logout
      v-if="LogOutModal"
      @logOut="logOut"
      @cancel="LogOutModal = !LogOutModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import axios from "axios";
// import $ from "jquery";
// import LogOutPopUp from "@/components/LogOutPopUp";
import Logout from "@/components/Logout.vue";

export default {
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "userInfo",
      "notificationCount",
      "permissionList",
      "messageCount",
    ]),
  },

  data() {
    return {
      logo_image: require(`${process.env.VUE_APP_COMS_LOGO}`),
      toggleMenuName: null,
      profileInfo: null,
      LogOutModal: false,
      notificationList: [],
      invitecourse: false,
      courselist: [],
      studentlist: [],
      invite_messages: "",
      mobileMenuOpen: false,
      loaders: false,
      disableStatus: false,
      invite_err_messages: "",
      searchQuery: "",
      showdetail: false,
      lengthCount: 10,
      messageList: [],
      // messagecount: null,
    };
  },

  components: {
    Logout,
  },

  created() {
    this.getNotifications();
    this.courselistget();
    this.studentlistget();
    // this.getMessages();
    if (this.userInfo) {
      let token = this.userInfo.token_key;
      let slug_id = this.userInfo.slug_id;
      axios
        .get(
          `${process.env.VUE_APP_API}/profile_detail/?Key=${token}&format=json`,
        )
        .then((response) => (this.profileInfo = response.data));
    } else {
      console.log("Not Login");
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.$store.dispatch("connectMessageSocket");

    this.$store.commit("SET_ON_NEW_MESSAGE", () => {
      this.loadMessages(this.currentPage);
    });

    this.loadMessages();
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    ...mapActions(["logOutUser"]),
    ...mapMutations(["notifyCount"]),
    async loadMessages(page = 1) {
      if (!this.userInfo) return;

      const data = await this.$store.dispatch("fetchMessageList", {
        userId: this.userInfo.user.id,
        token: this.userInfo.token_key,
        page,
      });

      this.messageList = data.data; // message array
    },
    // checkinTheList(feature) {
    //   let check = this.permissionList.find((x) => x === feature);
    //   if (check != undefined) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    checkinTheList(feature) {
  if (
    !Array.isArray(this.permissionList) ||
    this.permissionList.length === 0
  ) {
    return true;
  }

  return this.permissionList.includes(feature);
},
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "numeric",
        year: "numeric",
      });
    },
    formatDateTime(dateString) {
      const date = new Date(dateString);
      const now = new Date();

      const isSameDate =
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();

      if (isSameDate) {
        // Show only time if today
        return date.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      } else {
        // Show full date and time if not today
        return date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      }
    },
    MenuToggle(name) {
      if (this.toggleMenuName == name) {
        this.toggleMenuName = null;
      } else {
        this.toggleMenuName = name;
      }
    },

    async getNotifications() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/notifications/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response) {
            this.notificationList = response.data.data.data;
            this.lengthCount = this.notificationList.length;
          }
        });
    },

    async logOut() {
      await this.logOutUser();
      this.LogOutModal = false;
      this.$router.push({
        name: "Login",
      });
    },
    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.toggleMenuName = null;
      }
    },

    studentlistget() {
      axios
        .get(
          `${process.env.VUE_APP_API}/student-invite-email-get/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.data) {
            this.studentlist = res.data.data;
          }
        });
    },
    invitepost(el) {
      let bodyVal = {
        email: el.target.elements.studentmail.value,
        coures: el.target.elements.course.value,
        user: this.userInfo.user.id,
        status: true,
      };
      this.disableStatus = true;
      this.loaders = true;
      axios
        .post(
          `${process.env.VUE_APP_API}/invitation/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.invite_messages = response.data.message;

            this.loaders = false;

            setTimeout(() => {
              this.invite_messages = "";
              this.invitecourse = false;
              this.disableStatus = false;
              this.searchQuery = "";
              this.showdetail == false;
            }, 3000);
          } else if (response.data.status == 400) {
            this.loaders = false;
            this.invite_err_messages = response.data.error;
            setTimeout(() => {
              this.invite_err_messages = "";
              // this.invitecourse = false;
              this.disableStatus = false;
            }, 3000);
          } else {
            this.disableStatus = false;
          }
        })

        .finally(() => {
          this.loaders = false;
        });
    },
    courselistget() {
      axios
        .get(
          `${process.env.VUE_APP_API}/courses/?instructor=${this.userInfo.Instructor_id}&Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.data) {
            this.courselist = res.data.data.data.data;
          }
        });
    },

    Studentsearch() {
      this.showdetail = false;
      axios
        .get(
          `${process.env.VUE_APP_API}/student-invite-email-get/?search=${this.searchQuery}&${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.data) {
            this.studentlist = res.data.data;
            // this.showdetail == this.searchQuery.trim() !== "";
          }
        });
    },
    selectStudent(email) {
      this.searchQuery = email;
      this.showdetail = true;
      // this.invitecourse = false;
    },
    closepopup() {
      this.invitecourse = false;
      this.searchQuery = "";
      this.showdetail = false;
    },
    async getMessages() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/message-course-overall-details/?client__id=${this.userInfo.user.id}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response) {
            this.messageList = response.data.data.data;
            this.messagecount = response.data.count;
          }
        });
    },
  },
};
</script>

<style scoped>
/* loader  */
.spinner {
  --d: 8.6px;
  width: 1.5px;
  height: 1.5px;
  border-radius: 50%;
  color: #5593e0;
  box-shadow: calc(1 * var(--d)) calc(0 * var(--d)) 0 0,
    calc(0.707 * var(--d)) calc(0.707 * var(--d)) 0 0.5px,
    calc(0 * var(--d)) calc(1 * var(--d)) 0 1px,
    calc(-0.707 * var(--d)) calc(0.707 * var(--d)) 0 1.4px,
    calc(-1 * var(--d)) calc(0 * var(--d)) 0 1.9px,
    calc(-0.707 * var(--d)) calc(-0.707 * var(--d)) 0 2.4px,
    calc(0 * var(--d)) calc(-1 * var(--d)) 0 2.9px;
  animation: spinner-a90wxe 1s infinite steps(8);
}

@keyframes spinner-a90wxe {
  100% {
    transform: rotate(1turn);
  }
}
</style>
